import React, { useState } from "react";
import { api } from "../../lib/api";
import { formatApiError } from "../../lib/api";

export function Field({ label, children, hint }) {
  return (
    <div>
      <label style={{ display: "block", fontSize: 14, fontWeight: 500, marginBottom: 6 }}>{label}</label>
      {children}
      {hint && <div style={{ color: "var(--text-muted)", fontSize: 12, marginTop: 4 }}>{hint}</div>}
    </div>
  );
}

export function useFormSubmit(formType) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (data, onSubmitted) => {
    setBusy(true); setErr("");
    try {
      const { data: res } = await api.post("/forms/submit", { form_type: formType, data, send_email: true });
      onSubmitted(res);
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };
  return { submit, busy, err };
}

export function FormFooter({ busy, err, testid }) {
  return (
    <>
      {err && <div data-testid={`${testid}-error`} style={{ color: "var(--error)", fontSize: 14, marginTop: 8 }}>{err}</div>}
      <button data-testid={`${testid}-submit-btn`} className="btn-primary" type="submit" disabled={busy} style={{ justifyContent: "center", marginTop: 16 }}>
        {busy ? "Submitting…" : "Submit & Email PDF"}
      </button>
    </>
  );
}
